import deepClone from '../../foundation/js/deepClone'

export default {
    namespaced: true,
    state: {
        product_detail_image_data : undefined, 
        scraped_tablist_data: undefined
    },
    mutations:{
        set_product_detail_image_data(state, payload) {
            state.product_detail_image_data = payload
        },
        set_new_selected_image(state, payload) {
            state.product_detail_image_data.forEach(item => item.isSelected = false)
            state.product_detail_image_data[payload].isSelected = true
        },
        set_scraped_tablist_data(state, payload) {
            state.scraped_tablist_data = payload
        },
        set_selected_tab(state, payloadIndex) {
            const tempTablistData = deepClone(state.scraped_tablist_data)
            tempTablistData.forEach(tab => tab.isSelected = false)
            tempTablistData[payloadIndex].isSelected = true
            state.scraped_tablist_data = tempTablistData
        }
    }
}
